<template>
  <div class="content">
    <ul class="tab-tilte">
      <li @click="cur = 0" :class="{ active: cur == 0 }">
        知识产权对企业竞争力的作用
      </li>
      <li @click="cur = 1" :class="{ active: cur == 1 }">科技成果转化情况</li>
      <li @click="cur = 2" :class="{ active: cur == 2 }">
        研究开发与技术创新组织管理情况
      </li>
      <li @click="cur = 3" :class="{ active: cur == 3 }">管理与科技人员情况</li>
    </ul>
    <div class="tab-content">
      <div v-show="cur == 0">
        <p class="title">
          知识产权对企业竞争力的作用(限400字)
          <el-button
            type="primary"
            style="float: right; margin-top: -20px"
            @click="preservation"
            >保存</el-button
          >
        </p>
        <el-input
          type="textarea"
          maxlength="400"
          show-word-limit
          :rows="10"
          v-model="textData.bo.intellectualPropertyEffect"
        ></el-input>
      </div>
      <div v-show="cur == 1">
        <p class="title">
          科技成果转化情况(限400字)
          <el-button
            type="primary"
            style="float: right; margin-top: -20px"
            @click="preservation"
            >保存</el-button
          >
        </p>
        <el-input
          type="textarea"
          maxlength="400"
          show-word-limit
          :rows="10"
          v-model="textData.bo.transformationSituation"
        ></el-input>
        <div class="flex flex-end" style="margin-top: 20px">
          <el-button type="primary" @click="handleAdd">新增</el-button>
        </div>

        <el-dialog
          title="科技成果转化情况"
          :visible.sync="centerDialogVisible"
          width="66%"
          center
          v-loading="loading"
        >
          <el-form
            :model="formData"
            :rules="rules"
            ref="formData"
            class="demo-ruleForm"
          >
            <div>
              <div class="content">
                <!-- <p class="text">知识产权信息</p> -->
                <el-row type="flex" class="row-bg" justify="space-between">
                  <el-col :span="11">
                    <el-form-item
                      label="科技成果名称"
                      :maxlength="inputMax"
                      prop="approvalAchievementBO.achievementName"
                      label-width="40%"
                    >
                      <el-input
                        v-model="formData.approvalAchievementBO.achievementName"
                        placeholder="请填写"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="11">
                    <el-form-item
                      label="成果类型"
                      prop="approvalAchievementBO.achievementType"
                      label-width="40%"
                    >
                      <el-select
                        v-model="formData.approvalAchievementBO.achievementType"
                      >
                        <el-option
                          v-for="dict in achievementType"
                          :key="dict.id"
                          :label="dict.dictName"
                          :value="dict.dictCode"
                          placeholder="请选择"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="11">
                    <el-form-item
                      label="科技成果来源"
                      prop="approvalAchievementBO.achievementSource"
                      label-width="40%"
                    >
                      <el-select
                        v-model="
                          formData.approvalAchievementBO.achievementSource
                        "
                      >
                        <el-option
                          v-for="dict in achievementSource"
                          :key="dict.id"
                          :label="dict.dictName"
                          :value="dict.dictCode"
                          placeholder="请选择"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="11">
                    <el-form-item
                      label="转化结果"
                      prop="approvalAchievementBO.conversionResult"
                      label-width="40%"
                    >
                      <el-input
                        :maxlength="inputMax"
                        v-model="
                          formData.approvalAchievementBO.conversionResult
                        "
                        placeholder="请填写"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="11">
                    <el-form-item
                      label="转化时间"
                      prop="approvalAchievementBO.conversionTime"
                      label-width="40%"
                    >
                      <el-date-picker
                        :editable="false"
                        value-format="yyyy-MM-dd"
                        :picker-options="pickerOptions"
                        v-model="formData.approvalAchievementBO.conversionTime"
                        placeholder="请选择"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="11">
                    <el-form-item
                      label="证明材料类型"
                      prop="types"
                      label-width="40%"
                    >
                      <el-tooltip placement="bottom" effect="light">
                        <div slot="content">
                          科技成果转化证明材料包括知识产权授权证书或申请受理通知书、成果说明等;<br />内部转化可
                          生产,批文、新产品或新技术推广应用证明、品质量检验报告等方面提供材料;<br />外部转化
                          从技术合同、合作协议、发票等方面提供材料。
                        </div>
                        <el-select multiple="true" v-model="formData.types">
                          <el-option
                            v-for="item in materials"
                            :key="item.dictCode"
                            :label="item.dictName"
                            :value="item.dictCode"
                          ></el-option>
                        </el-select>
                      </el-tooltip>
                    </el-form-item>
                  </el-col>
                  <el-col :span="24">
                    <el-form-item
                      label="证明材料(pdf)"
                      prop=""
                      label-width="20%"
                    >
                      <el-upload
                        ref="upload"
                        class="upload-demo"
                        :action="uploadImgUrl"
                        :on-success="quillImgSuccess"
                        :on-preview="handleView"
                        :on-remove="handleRemove"
                        :on-error="uploadError"
                        :before-upload="beforeUpload"
                        :data="{ moduleType: 20 }"
                        accept="application/pdf"
                        :file-list="fileList"
                      >
                        <el-button size="small" type="primary"
                          >点击上传</el-button
                        >
                      </el-upload>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
            </div>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="centerDialogVisible = false">返回</el-button>
            <el-button
              type="primary"
              @click="classSubmitForm"
              :disabled="disabled"
              >保存</el-button
            >
          </span>
        </el-dialog>

        <el-table
          class="table"
          :data="datas"
          :header-cell-style="{ background: '#F5F7FA' }"
          stripe
        >
          <el-table-column label="序号" width="100" prop="date">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="achievementName" label="科技成果名称">
          </el-table-column>
          <el-table-column
            prop="achievementTypeStr"
            label="成果类型"
          ></el-table-column>
          <el-table-column
            label="科技成果来源"
            prop="achievementSourceStr"
          ></el-table-column>
          <el-table-column
            label="转化结果"
            prop="conversionResult"
          ></el-table-column>
          <el-table-column
            label="转化时间"
            prop="conversionTime"
          ></el-table-column>

          <el-table-column label="操作" width="140" fixed="right">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                class="green"
                @click="handleUpdate(scope.row.id)"
                >编辑</el-button
              >
              <el-button
                type="text"
                size="small"
                class="red"
                @click="handleDelete(scope.row.id)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="flex flex-end">
          <el-pagination
            class="pagination"
            background
            v-show="total > 0"
            :total="total"
            :current-page.sync="queryParams.pageNum"
            :page-size.sync="queryParams.pageSize"
            @current-change="getList"
          >
          </el-pagination>
        </div>
      </div>
      <div v-show="cur == 2" v-loading="loading">
        <p class="title">
          研究开发与技术创新组织管理情况(限400字)
          <el-button
            type="primary"
            style="float: right; margin-top: -20px"
            @click="preservation"
            v-loading="loading"
            >保存</el-button
          >
        </p>
        <el-input
          type="textarea"
          maxlength="400"
          show-word-limit
          :rows="10"
          v-model="textData.bo.administrativeSituation"
        ></el-input>
        <div class="upload_box" style="margin-top: 20px">
          <div class="txt" style="font-size: 12px">
            <p>附件格式要求：</p>
            <p>1、证明材料扫描上传</p>
            <p>2、只支持非加密PDF格式的文件上传</p>
            <p>3、单个文件大小不要超过4M</p>
          </div>
          <p style="font-size: 14px">
            1、制定了企业研究开发的组织管理制度，请上传企业研究开发的组织管理制度具体证明材料。
          </p>
          <el-upload
            class="upload-demo"
            :action="uploadImgUrl"
            accept="application/pdf"
            :before-upload="beforeUploadZd"
            :on-success="quillImgSuccessZd"
            :on-preview="handleView"
            :on-remove="handleRemoveZd"
            :on-error="uploadErrorZd"
            :data="{ moduleType: 33 }"
            :file-list="zFileList"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </div>

        <div class="upload_box" style="margin-top: 20px">
          <p style="font-size: 14px">
            2、建立了研发投入核算体系，请上传研发投入核算体系证明材料。
          </p>
          <el-upload
            class="upload-demo"
            :action="uploadImgUrl"
            accept="application/pdf"
            :before-upload="beforeUploadSl"
            :on-success="quillImgSuccessSl"
            :on-preview="handleView"
            :on-remove="handleRemoveSl"
            :on-error="uploadErrorSl"
            :data="{ moduleType: 34 }"
            :file-list="sFileList"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </div>

        <div class="upload_box" style="margin-top: 20px">
          <p style="font-size: 14px">
            3、编制了研发费用辅助账证明材料，请上传研发费用辅助账具体证明材料。
          </p>
          <el-upload
            class="upload-demo"
            :action="uploadImgUrl"
            accept="application/pdf"
            :before-upload="beforeUploadZz"
            :on-success="quillImgSuccessZz"
            :on-preview="handleView"
            :on-remove="handleRemoveZz"
            :on-error="uploadErrorZz"
            :data="{ moduleType: 35 }"
            :file-list="jFileList"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </div>

        <div class="upload_box" style="margin-top: 20px">
          <p style="font-size: 14px">
            4、设立内部科学技术研究开发机构并具备相应科研条件，请上传企业内部科学技术研究开发机构并具备相应科研条件具体证明材料。
          </p>
          <el-upload
            class="upload-demo"
            :action="uploadImgUrl"
            accept="application/pdf"
            :before-upload="beforeUploadJx"
            :on-success="quillImgSuccessJx"
            :on-preview="handleView"
            :on-remove="handleRemoveJx"
            :on-error="uploadErrorJx"
            :data="{ moduleType: 36 }"
            :file-list="xFileList"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </div>

        <div class="upload_box" style="margin-top: 20px">
          <p style="font-size: 14px">
            5、与国内外研究开发机构开展多种形式的产学研合作，请上传与国内外研究开发机构开展多种形式的产学研合作具体证明材料。
          </p>
          <el-upload
            class="upload-demo"
            :action="uploadImgUrl"
            accept="application/pdf"
            :before-upload="beforeUploadAA"
            :on-success="quillImgSuccessAA"
            :on-preview="handleView"
            :on-remove="handleRemoveAA"
            :on-error="uploadErrorAA"
            :data="{ moduleType: 37 }"
            :file-list="aList"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </div>
        <div class="upload_box" style="margin-top: 20px">
          <p style="font-size: 14px">
            6、建立了科技成果转化的组织实施与激励奖励制度，请上传科技成果转化的组织实施与激励奖励制度体证明材料。
          </p>
          <el-upload
            class="upload-demo"
            :action="uploadImgUrl"
            accept="application/pdf"
            :before-upload="beforeUploadBB"
            :on-success="quillImgSuccessBB"
            :on-preview="handleView"
            :on-remove="handleRemoveBB"
            :on-error="uploadErrorBB"
            :data="{ moduleType: 38 }"
            :file-list="bList"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </div>
        <div class="upload_box" style="margin-top: 20px">
          <p style="font-size: 14px">
            7、建立开放式的创新创业平台，请上传开放式的创新创业平台具体证明材料。
          </p>
          <el-upload
            class="upload-demo"
            :action="uploadImgUrl"
            accept="application/pdf"
            :before-upload="beforeUploadCC"
            :on-success="quillImgSuccessCC"
            :on-preview="handleView"
            :on-remove="handleRemoveCC"
            :on-error="uploadErrorCC"
            :data="{ moduleType: 39 }"
            :file-list="cList"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </div>
        <div class="upload_box" style="margin-top: 20px">
          <p style="font-size: 14px">
            8、建立了科技人员的培养进修、职工技能培训，请上传科技人员的培养进修、职工技能培训具体证明材料。
          </p>
          <el-upload
            class="upload-demo"
            :action="uploadImgUrl"
            accept="application/pdf"
            :before-upload="beforeUploadDD"
            :on-success="quillImgSuccessDD"
            :on-preview="handleView"
            :on-remove="handleRemoveDD"
            :on-error="uploadErrorDD"
            :data="{ moduleType: 40 }"
            :file-list="dList"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </div>
        <div class="upload_box" style="margin-top: 20px">
          <p style="font-size: 14px">
            9、建立了优秀人才引进制度，请上传优秀人才引进具体证明材料。
          </p>
          <el-upload
            class="upload-demo"
            :action="uploadImgUrl"
            accept="application/pdf"
            :before-upload="beforeUploadEE"
            :on-success="quillImgSuccessEE"
            :on-preview="handleView"
            :on-remove="handleRemoveEE"
            :on-error="uploadErrorEE"
            :data="{ moduleType: 41 }"
            :file-list="eList"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </div>
        <div class="upload_box" style="margin-top: 20px">
          <p style="font-size: 14px">
            10、建立了人才绩效评价奖励制度，请上传科人才绩效评价奖励制度具体证明材料。
          </p>
          <el-upload
            class="upload-demo"
            :action="uploadImgUrl"
            accept="application/pdf"
            :before-upload="beforeUploadFF"
            :on-success="quillImgSuccessFF"
            :on-preview="handleView"
            :on-remove="handleRemoveFF"
            :on-error="uploadErrorFF"
            :data="{ moduleType: 42 }"
            :file-list="fList"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </div>
      </div>
      <div v-show="cur == 3">
        <p class="title">
          管理与科技人员情况(限400字)
          <el-button
            type="primary"
            style="float: right; margin-top: -20px"
            @click="preservation"
            >保存</el-button
          >
        </p>
        <el-input
          type="textarea"
          maxlength="400"
          show-word-limit
          :rows="10"
          v-model="textData.bo.staffSituation"
        ></el-input>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getDict,
  getModuleFiles,
  commonFileGetMultiFiles,
  innovationAbilityAbilityQuery,
  innovationAbilityAbilitySave,
  innovationAbilityAchievementQueryAll,
  innovationAbilityAchievementQuery,
  innovationAbilityAchievementSave,
  innovationAbilityAchievementDelete,
} from "@/api/ChinaHigh";

export default {
  name: "innovate",
  props: {
    id: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      cur: 0,
      text: "",
      centerDialogVisible: false,
      formData: {
        approvalAchievementBO: {},
        fileBindVOList: [],
      },
      rules: {
        "approvalAchievementBO.achievementName": [
          { required: true, message: "请输入科技成果名称", trigger: "blur" },
        ],
        "approvalAchievementBO.achievementType": [
          { required: true, message: "请选择成果类型", trigger: "change" },
        ],
        "approvalAchievementBO.achievementSource": [
          { required: true, message: "请选择科技成果来源", trigger: "change" },
        ],
        "approvalAchievementBO.conversionResult": [
          { required: true, message: "请输入转化结果", trigger: "blur" },
        ],
        "approvalAchievementBO.conversionTime": [
          { required: true, message: "请选择转化时间", trigger: "change" },
        ],
        types: [
          { required: true, message: "请选择证明材料类型", trigger: "change" },
        ],
      },
      // 数据
      datas: [],
      // 搜索
      queryParams: {
        pageNum: 1,
        pageSize: 10,
      },
      materials: [],
      // 遮罩层
      loading: false,
      total: 0,
      textData: {
        bo: {},
        fileBindVOList: {},
      },
      //日期限制
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;
        },
      },
      achievementType: {},
      achievementSource: {},
      fileList: [],
      zFileList: [],
      sFileList: [],
      jFileList: [],
      xFileList: [],
      aList: [],
      bList: [],
      cList: [],
      dList: [],
      eList: [],
      fList: [],
      disabled: false,
      disabledZd: false,
      disabledSl: false,
      disabledZz: false,
      disabledJx: false,
      disabledAA: false,
      disabledBB: false,
      disabledCC: false,
      disabledDD: false,
      disabledEE: false,
      disabledFF: false,
    };
  },
  created() {
    this.chushih();
    this.handleQuery();
  },
  methods: {
    // 创新数据
    chushih() {
      innovationAbilityAbilityQuery(this.id).then((res) => {
        if (res.data === null) {
          this.textData = {
            bo: {},
            fileBindVOList: [],
          };
        } else {
          this.textData.bo = res.data;
          this.textData.fileBindVOList = [];
        }
        this.zFileList = [];
        this.sFileList = [];
        this.jFileList = [];
        this.xFileList = [];
        this.aList = [];
        this.bList = [];
        this.cList = [];
        this.dList = [];
        this.eList = [];
        this.fList = [];

        commonFileGetMultiFiles({
          moduleId: this.id,
          moduleTypes: [33, 34, 35, 36, 37, 38, 39, 40, 41, 42],
        }).then((res) => {
          res.data.forEach((data) => {
            var datas = {
              name: data.fileName,
              fileName: data.fileName,
              url: data.url,
              moduleId: data.moduleId,
              moduleType: data.moduleType,
              path: data.path,
              id: data.id,
            };
            this.textData.fileBindVOList.push(datas);
            this.typeData(datas);
          });
        });
      });
    },
    typeData(data) {
      var type = data.moduleType;
      if (type == 33) {
        this.zFileList.push(data);
      }
      if (type == 34) {
        this.sFileList.push(data);
      }
      if (type == 35) {
        this.jFileList.push(data);
      }
      if (type == 36) {
        this.xFileList.push(data);
      }
      if (type == 37) {
        this.aList.push(data);
      }
      if (type == 38) {
        this.bList.push(data);
      }
      if (type == 39) {
        this.cList.push(data);
      }
      if (type == 40) {
        this.dList.push(data);
      }
      if (type == 41) {
        this.eList.push(data);
      }
      if (type == 42) {
        this.fList.push(data);
      }
    },
    // 保存信息
    preservation() {
      this.textData.bo.approvalId = this.id;
      this.textData.fileBindVOList = [
        ...this.zFileList,
        ...this.sFileList,
        ...this.jFileList,
        ...this.xFileList,
        ...this.aList,
        ...this.bList,
        ...this.cList,
        ...this.dList,
        ...this.eList,
        ...this.fList,
      ];
      this.textData.fileBindVOList.push({ moduleId: this.id, moduleType: 33 });
      this.textData.fileBindVOList.push({ moduleId: this.id, moduleType: 34 });
      this.textData.fileBindVOList.push({ moduleId: this.id, moduleType: 35 });
      this.textData.fileBindVOList.push({ moduleId: this.id, moduleType: 36 });
      this.textData.fileBindVOList.push({ moduleId: this.id, moduleType: 37 });
      this.textData.fileBindVOList.push({ moduleId: this.id, moduleType: 38 });
      this.textData.fileBindVOList.push({ moduleId: this.id, moduleType: 39 });
      this.textData.fileBindVOList.push({ moduleId: this.id, moduleType: 40 });
      this.textData.fileBindVOList.push({ moduleId: this.id, moduleType: 41 });
      this.textData.fileBindVOList.push({ moduleId: this.id, moduleType: 42 });
      innovationAbilityAbilitySave(this.textData).then((res) => {
        if (res.code === "00000") {
          this.chushih();
          this.centerDialogVisible = false;
          this.msgSuccess(res.msg);
        }
      });
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.approvalId = this.id;
      this.queryParams.pageNum = 1;
      this.queryParams.pageSize = 10;
      this.getList();
    },
    /** 列表 */
    getList() {
      this.loading = true;
      innovationAbilityAchievementQueryAll(this.queryParams).then((res) => {
        this.datas = res.data.records;
        this.total = res.data.total;
        this.loading = false;
      });
    },
    chushi() {
      // 成果类型
      getDict({ type: "scientific_achievements_type" }).then((res) => {
        this.achievementType = res.data;
      });
      // 成果来源
      getDict({ type: "intellectual_property_access" }).then((res) => {
        this.achievementSource = res.data;
      });
      getDict({ type: "m_type" }).then((res) => {
        this.materials = res.data;
      });
      this.formData = {
        approvalAchievementBO: {},
        types: [],
        fileBindVOList: [],
      };
      // console.log(this.formData)
      this.fileList = [];
      this.resetFiles("upload");
      this.resetForm("formData");
    },
    handleAdd() {
      this.materials = [];
      this.chushi();
      this.centerDialogVisible = true;
    },
    handleUpdate(id) {
      this.chushi();
      innovationAbilityAchievementQuery(id).then((res) => {
        this.formData.approvalAchievementBO = res.data.approvalAchievementBO;
        this.formData.types = res.data.types;
        this.formData.fileBindVOList = [];
        getModuleFiles({
          moduleId: res.data.approvalAchievementBO.id,
          moduleType: 20,
        }).then((res) => {
          this.formData.fileBindVOList = res.data;
          res.data.forEach((re) => {
            this.fileList.push({
              name: re.fileName,
              fileName: re.fileName,
              url: re.url,
              moduleId: re.moduleId,
              moduleType: re.moduleType,
              path: re.path,
              id: re.id,
            });
          });
        });
        this.centerDialogVisible = true;
      });
    },
    classSubmitForm() {
      this.formData.approvalAchievementBO.approvalId = this.id;
      this.formData.fileBindVOList.push({ moduleId: this.id, moduleType: 20 });
      this.$refs["formData"].validate((valid) => {
        if (valid) {
          innovationAbilityAchievementSave(this.formData).then((res) => {
            if (res.code === "00000") {
              this.handleQuery();
              this.centerDialogVisible = false;
              this.msgSuccess(res.msg);
            }
          });
        } else {
          return false;
        }
      });
    },
    handleDelete(id) {
      var that = this;
      this.$confirm("是否确认删除科技成果吗?", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(function () {
          return innovationAbilityAchievementDelete({
            approvalId: that.id,
            ids: [id],
          });
        })
        .then(() => {
          this.getList();
          this.msgSuccess("删除成功");
        })
        .catch(function () {});
    },
    beforeUpload(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension = testmsg === "pdf";
      const isLt2M = file.size / 1024 / 1024 <= 4;
      if (!extension) {
        this.msgError("上传文件只能是pdf文件");
      }

      if (!isLt2M) {
        this.msgError("上传文件大小不能超过4M");
      }
      let disabledCx = false;
      if (!extension && !isLt2M && this.disabled) {
        disabledCx = true;
      }
      if (extension && isLt2M) {
        disabledCx = true;
      }
      // this.loading=true;
      this.disabled = disabledCx;
      return extension && isLt2M;
    },
    // 上传成功
    quillImgSuccess(res, file, fileList) {
      this.loading = false;
      // 如果上传成功
      if (res.code === "00000") {
        this.formData.fileBindVOList.push(res.data);
        this.msgSuccess("附件上传成功");
      } else {
        this.msgError("附件上传失败");
      }
      let status = "";
      fileList.some((res) => {
        if (res.status != "success") {
          status = 1;
          return;
        }
      });
      if (status != 1) {
        this.disabled = false;
      }
    },
    // 图片删除
    handleRemove(file, fileList) {
      this.formData.fileBindVOList = [];
      fileList.forEach((res) => {
        if (res.response == undefined) {
          this.formData.fileBindVOList.push(res);
        } else {
          this.formData.fileBindVOList.push(res.response.data);
        }
      });
      this.formData.fileBindVOList.push({ moduleId: this.id, moduleType: 33 });
      this.formData.fileBindVOList.push({ moduleId: this.id, moduleType: 34 });
      this.formData.fileBindVOList.push({ moduleId: this.id, moduleType: 35 });
      this.formData.fileBindVOList.push({ moduleId: this.id, moduleType: 36 });
      this.formData.fileBindVOList.push({ moduleId: this.id, moduleType: 37 });
      this.formData.fileBindVOList.push({ moduleId: this.id, moduleType: 38 });
      this.formData.fileBindVOList.push({ moduleId: this.id, moduleType: 39 });
      this.formData.fileBindVOList.push({ moduleId: this.id, moduleType: 40 });
      this.formData.fileBindVOList.push({ moduleId: this.id, moduleType: 41 });
      this.formData.fileBindVOList.push({ moduleId: this.id, moduleType: 42 });
      this.centerDialogVisible = true;
    },
    // 富文本图片上传失败
    uploadError(err, file, fileList) {
      this.loading = false;
      if (fileList.length > 0) {
        let status = "";
        fileList.some((res) => {
          if (res.status != "success") {
            status = 1;
            return;
          }
        });
        if (status != 1) {
          this.disabled = false;
        }
      } else {
        this.disabled = false;
      }
      // loading动画消失
      this.msgError("图片上传失败");
      this.loading = false;
    },
    beforeUploadZd(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension = testmsg === "pdf";
      const isLt2M = file.size / 1024 / 1024 <= 4;
      if (!extension) {
        this.msgError("上传文件只能是pdf文件");
      }

      if (!isLt2M) {
        this.msgError("上传文件大小不能超过4M");
      }
      let disabledCx = false;
      if (!extension && !isLt2M && this.disabledZd) {
        disabledCx = true;
      }
      if (extension && isLt2M) {
        disabledCx = true;
      }
      this.disabledZd = disabledCx;
      // this.loading=true;
      return extension && isLt2M;
    },
    // 上传成功
    quillImgSuccessZd(res, file, fileList) {
      this.loading = false;
      // 如果上传成功
      if (res.code === "00000") {
        this.zFileList.push({
          name: res.data.fileName,
          fileName: res.data.fileName,
          url: res.data.url,
          moduleId: res.data.moduleId,
          moduleType: res.data.moduleType,
          path: res.data.path,
        });
        this.msgSuccess("附件上传成功");
      } else {
        this.msgError("附件上传失败");
      }
      let status = "";
      fileList.some((res) => {
        if (res.status != "success") {
          status = 1;
          return;
        }
      });
      if (status != 1) {
        this.disabledZd = false;
      }
    },
    // 图片删除
    handleRemoveZd(file, fileList) {
      this.zFileList = [];
      fileList.forEach((res) => {
        if (res.response == undefined) {
          this.zFileList.push(res);
        } else {
          this.zFileList.push(res.response.data);
        }
      });
    },
    // 富文本图片上传失败
    uploadErrorZd(err, file, fileList) {
      if (fileList.length > 0) {
        let status = "";
        fileList.some((res) => {
          if (res.status != "success") {
            status = 1;
            return;
          }
        });
        if (status != 1) {
          this.disabledZd = false;
        }
      } else {
        this.disabledZd = false;
      }
      // loading动画消失
      this.msgError("图片上传失败");
      this.loading = false;
    },
    beforeUploadSl(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension = testmsg === "pdf";
      const isLt2M = file.size / 1024 / 1024 <= 4;
      if (!extension) {
        this.msgError("上传文件只能是pdf文件");
      }

      if (!isLt2M) {
        this.msgError("上传文件大小不能超过4M");
      }
      let disabledCx = false;
      if (!extension && !isLt2M && this.disabledSl) {
        disabledCx = true;
      }
      if (extension && isLt2M) {
        disabledCx = true;
      }
      this.disabledSl = disabledCx;
      // this.loading=true;
      return extension && isLt2M;
    },
    // 上传成功
    quillImgSuccessSl(res, file, fileList) {
      this.loading = false;
      // 如果上传成功
      if (res.code === "00000") {
        this.sFileList.push({
          name: res.data.fileName,
          fileName: res.data.fileName,
          url: res.data.url,
          moduleId: res.data.moduleId,
          moduleType: res.data.moduleType,
          path: res.data.path,
        });
        this.msgSuccess("附件上传成功");
      } else {
        this.msgError("附件上传失败");
      }
      let status = "";
      fileList.some((res) => {
        if (res.status != "success") {
          status = 1;
          return;
        }
      });
      if (status != 1) {
        this.disabledSl = false;
      }
    },
    // 图片删除
    handleRemoveSl(file, fileList) {
      this.sFileList = [];
      fileList.forEach((res) => {
        if (res.response == undefined) {
          this.sFileList.push(res);
        } else {
          this.sFileList.push(res.response.data);
        }
      });
    },
    // 富文本图片上传失败
    uploadErrorSl(err, file, fileList) {
      if (fileList.length > 0) {
        let status = "";
        fileList.some((res) => {
          if (res.status != "success") {
            status = 1;
            return;
          }
        });
        if (status != 1) {
          this.disabledSl = false;
        }
      } else {
        this.disabledSl = false;
      }
      // loading动画消失
      this.msgError("图片上传失败");
      this.loading = false;
    },

    beforeUploadZz(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension = testmsg === "pdf";
      const isLt2M = file.size / 1024 / 1024 <= 4;
      if (!extension) {
        this.msgError("上传文件只能是pdf文件");
      }

      if (!isLt2M) {
        this.msgError("上传文件大小不能超过4M");
      }
      let disabledCx = false;
      if (!extension && !isLt2M && this.disabledZz) {
        disabledCx = true;
      }
      if (extension && isLt2M) {
        disabledCx = true;
      }
      this.disabledZz = disabledCx;
      // this.loading=true;
      return extension && isLt2M;
    },
    // 上传成功
    quillImgSuccessZz(res, file, fileList) {
      this.loading = false;
      // 如果上传成功
      if (res.code === "00000") {
        this.jFileList.push({
          name: res.data.fileName,
          fileName: res.data.fileName,
          url: res.data.url,
          moduleId: res.data.moduleId,
          moduleType: res.data.moduleType,
          path: res.data.path,
        });
        this.msgSuccess("附件上传成功");
      } else {
        this.msgError("附件上传失败");
      }
      let status = "";
      fileList.some((res) => {
        if (res.status != "success") {
          status = 1;
          return;
        }
      });
      if (status != 1) {
        this.disabledZz = false;
      }
    },
    // 图片删除
    handleRemoveZz(file, fileList) {
      this.jFileList = [];
      fileList.forEach((res) => {
        if (res.response == undefined) {
          this.jFileList.push(res);
        } else {
          this.jFileList.push(res.response.data);
        }
      });
    },
    // 富文本图片上传失败
    uploadErrorZz(err, file, fileList) {
      if (fileList.length > 0) {
        let status = "";
        fileList.some((res) => {
          if (res.status != "success") {
            status = 1;
            return;
          }
        });
        if (status != 1) {
          this.disabledZz = false;
        }
      } else {
        this.disabledZz = false;
      }
      // loading动画消失
      this.msgError("图片上传失败");
      this.loading = false;
    },

    beforeUploadJx(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension = testmsg === "pdf";
      const isLt2M = file.size / 1024 / 1024 <= 4;
      if (!extension) {
        this.msgError("上传文件只能是pdf文件");
      }

      if (!isLt2M) {
        this.msgError("上传文件大小不能超过4M");
      }
      let disabledCx = false;
      if (!extension && !isLt2M && this.disabledJx) {
        disabledCx = true;
      }
      if (extension && isLt2M) {
        disabledCx = true;
      }
      this.disabledJx = disabledCx;
      // this.loading=true;
      return extension && isLt2M;
    },
    // 上传成功
    quillImgSuccessJx(res, file, fileList) {
      this.loading = false;
      // 如果上传成功
      if (res.code === "00000") {
        this.xFileList.push({
          name: res.data.fileName,
          fileName: res.data.fileName,
          url: res.data.url,
          moduleId: res.data.moduleId,
          moduleType: res.data.moduleType,
          path: res.data.path,
        });
        this.msgSuccess("附件上传成功");
      } else {
        this.msgError("附件上传失败");
      }
      let status = "";
      fileList.some((res) => {
        if (res.status != "success") {
          status = 1;
          return;
        }
      });
      if (status != 1) {
        this.disabledJx = false;
      }
    },
    // 图片删除
    handleRemoveJx(file, fileList) {
      this.xFileList = [];
      fileList.forEach((res) => {
        if (res.response == undefined) {
          this.xFileList.push(res);
        } else {
          this.xFileList.push(res.response.data);
        }
      });
    },
    // 富文本图片上传失败
    uploadErrorJx(err, file, fileList) {
      if (fileList.length > 0) {
        let status = "";
        fileList.some((res) => {
          if (res.status != "success") {
            status = 1;
            return;
          }
        });
        if (status != 1) {
          this.disabledJx = false;
        }
      } else {
        this.disabledJx = false;
      }
      // loading动画消失
      this.msgError("图片上传失败");
      this.loading = false;
    },

    // --------------------------------------------------------------
    beforeUploadAA(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension = testmsg === "pdf";
      const isLt2M = file.size / 1024 / 1024 <= 4;
      if (!extension) {
        this.msgError("上传文件只能是pdf文件");
      }

      if (!isLt2M) {
        this.msgError("上传文件大小不能超过4M");
      }
      let disabledCx = false;
      if (!extension && !isLt2M && this.disabledAA) {
        disabledCx = true;
      }
      if (extension && isLt2M) {
        disabledCx = true;
      }
      this.disabledAA = disabledCx;
      // this.loading=true;
      return extension && isLt2M;
    },
    // 上传成功
    quillImgSuccessAA(res, file, fileList) {
      this.loading = false;
      // 如果上传成功
      if (res.code === "00000") {
        this.aList.push({
          name: res.data.fileName,
          fileName: res.data.fileName,
          url: res.data.url,
          moduleId: res.data.moduleId,
          moduleType: res.data.moduleType,
          path: res.data.path,
        });
        this.msgSuccess("附件上传成功");
      } else {
        this.msgError("附件上传失败");
      }
      console.log(this.aList);
      let status = "";
      fileList.some((res) => {
        if (res.status != "success") {
          status = 1;
          return;
        }
      });
      if (status != 1) {
        this.disabledAA = false;
      }
    },
    // 图片删除
    handleRemoveAA(file, fileList) {
      this.aList = [];
      fileList.forEach((res) => {
        if (res.response == undefined) {
          this.aList.push(res);
        } else {
          this.aList.push(res.response.data);
        }
      });
    },
    // 富文本图片上传失败
    uploadErrorAA(err, file, fileList) {
      if (fileList.length > 0) {
        let status = "";
        fileList.some((res) => {
          if (res.status != "success") {
            status = 1;
            return;
          }
        });
        if (status != 1) {
          this.disabledAA = false;
        }
      } else {
        this.disabledAA = false;
      }
      // loading动画消失
      this.msgError("图片上传失败");
      this.loading = false;
    },
    // --------------------------------------------------------------
    beforeUploadBB(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension = testmsg === "pdf";
      const isLt2M = file.size / 1024 / 1024 <= 4;
      if (!extension) {
        this.msgError("上传文件只能是pdf文件");
      }

      if (!isLt2M) {
        this.msgError("上传文件大小不能超过4M");
      }
      let disabledCx = false;
      if (!extension && !isLt2M && this.disabledBB) {
        disabledCx = true;
      }
      if (extension && isLt2M) {
        disabledCx = true;
      }
      this.disabledBB = disabledCx;
      // this.loading=true;
      return extension && isLt2M;
    },
    // 上传成功
    quillImgSuccessBB(res, file, fileList) {
      this.loading = false;
      // 如果上传成功
      if (res.code === "00000") {
        this.bList.push({
          name: res.data.fileName,
          fileName: res.data.fileName,
          url: res.data.url,
          moduleId: res.data.moduleId,
          moduleType: res.data.moduleType,
          path: res.data.path,
        });
        this.msgSuccess("附件上传成功");
      } else {
        this.msgError("附件上传失败");
      }
      console.log(this.bList);
      let status = "";
      fileList.some((res) => {
        if (res.status != "success") {
          status = 1;
          return;
        }
      });
      if (status != 1) {
        this.disabledBB = false;
      }
    },
    // 图片删除
    handleRemoveBB(file, fileList) {
      this.bList = [];
      fileList.forEach((res) => {
        if (res.response == undefined) {
          this.bList.push(res);
        } else {
          this.bList.push(res.response.data);
        }
      });
    },
    // 富文本图片上传失败
    uploadErrorBB(err, file, fileList) {
      if (fileList.length > 0) {
        let status = "";
        fileList.some((res) => {
          if (res.status != "success") {
            status = 1;
            return;
          }
        });
        if (status != 1) {
          this.disabledBB = false;
        }
      } else {
        this.disabledBB = false;
      }
      // loading动画消失
      this.msgError("图片上传失败");
      this.loading = false;
    },

    // --------------------------------------------------------------
    beforeUploadCC(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension = testmsg === "pdf";
      const isLt2M = file.size / 1024 / 1024 <= 4;
      if (!extension) {
        this.msgError("上传文件只能是pdf文件");
      }

      if (!isLt2M) {
        this.msgError("上传文件大小不能超过4M");
      }
      let disabledCx = false;
      if (!extension && !isLt2M && this.disabledCC) {
        disabledCx = true;
      }
      if (extension && isLt2M) {
        disabledCx = true;
      }
      this.disabledCC = disabledCx;
      // this.loading=true;
      return extension && isLt2M;
    },
    // 上传成功
    quillImgSuccessCC(res, file, fileList) {
      this.loading = false;
      // 如果上传成功
      if (res.code === "00000") {
        this.cList.push({
          name: res.data.fileName,
          fileName: res.data.fileName,
          url: res.data.url,
          moduleId: res.data.moduleId,
          moduleType: res.data.moduleType,
          path: res.data.path,
        });
        this.msgSuccess("附件上传成功");
      } else {
        this.msgError("附件上传失败");
      }
      console.log(this.cList);
      let status = "";
      fileList.some((res) => {
        if (res.status != "success") {
          status = 1;
          return;
        }
      });
      if (status != 1) {
        this.disabledCC = false;
      }
    },
    // 图片删除
    handleRemoveCC(file, fileList) {
      this.cList = [];
      fileList.forEach((res) => {
        if (res.response == undefined) {
          this.cList.push(res);
        } else {
          this.cList.push(res.response.data);
        }
      });
    },
    // 富文本图片上传失败
    uploadErrorCC(err, file, fileList) {
      if (fileList.length > 0) {
        let status = "";
        fileList.some((res) => {
          if (res.status != "success") {
            status = 1;
            return;
          }
        });
        if (status != 1) {
          this.disabledCC = false;
        }
      } else {
        this.disabledCC = false;
      }
      // loading动画消失
      this.msgError("图片上传失败");
      this.loading = false;
    },

    // --------------------------------------------------------------
    beforeUploadDD(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension = testmsg === "pdf";
      const isLt2M = file.size / 1024 / 1024 <= 4;
      if (!extension) {
        this.msgError("上传文件只能是pdf文件");
      }

      if (!isLt2M) {
        this.msgError("上传文件大小不能超过4M");
      }
      let disabledCx = false;
      if (!extension && !isLt2M && this.disabledDD) {
        disabledCx = true;
      }
      if (extension && isLt2M) {
        disabledCx = true;
      }
      this.disabledDD = disabledCx;
      // this.loading=true;
      return extension && isLt2M;
    },
    // 上传成功
    quillImgSuccessDD(res, file, fileList) {
      this.loading = false;
      // 如果上传成功
      if (res.code === "00000") {
        this.dList.push({
          name: res.data.fileName,
          fileName: res.data.fileName,
          url: res.data.url,
          moduleId: res.data.moduleId,
          moduleType: res.data.moduleType,
          path: res.data.path,
        });
        this.msgSuccess("附件上传成功");
      } else {
        this.msgError("附件上传失败");
      }
      console.log(this.dList);
      let status = "";
      fileList.some((res) => {
        if (res.status != "success") {
          status = 1;
          return;
        }
      });
      if (status != 1) {
        this.disabledDD = false;
      }
    },
    // 图片删除
    handleRemoveDD(file, fileList) {
      this.dList = [];
      fileList.forEach((res) => {
        if (res.response == undefined) {
          this.dList.push(res);
        } else {
          this.dList.push(res.response.data);
        }
      });
    },
    // 富文本图片上传失败
    uploadErrorDD(err, file, fileList) {
      if (fileList.length > 0) {
        let status = "";
        fileList.some((res) => {
          if (res.status != "success") {
            status = 1;
            return;
          }
        });
        if (status != 1) {
          this.disabledDD = false;
        }
      } else {
        this.disabledDD = false;
      }
      // loading动画消失
      this.msgError("图片上传失败");
      this.loading = false;
    },

    // --------------------------------------------------------------
    beforeUploadEE(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension = testmsg === "pdf";
      const isLt2M = file.size / 1024 / 1024 <= 4;
      if (!extension) {
        this.msgError("上传文件只能是pdf文件");
      }

      if (!isLt2M) {
        this.msgError("上传文件大小不能超过4M");
      }
      let disabledCx = false;
      if (!extension && !isLt2M && this.disabledEE) {
        disabledCx = true;
      }
      if (extension && isLt2M) {
        disabledCx = true;
      }
      this.disabledEE = disabledCx;
      // this.loading=true;
      return extension && isLt2M;
    },
    // 上传成功
    quillImgSuccessEE(res, file, fileList) {
      this.loading = false;
      // 如果上传成功
      if (res.code === "00000") {
        this.eList.push({
          name: res.data.fileName,
          fileName: res.data.fileName,
          url: res.data.url,
          moduleId: res.data.moduleId,
          moduleType: res.data.moduleType,
          path: res.data.path,
        });
        this.msgSuccess("附件上传成功");
      } else {
        this.msgError("附件上传失败");
      }
      console.log(this.eList);
      let status = "";
      fileList.some((res) => {
        if (res.status != "success") {
          status = 1;
          return;
        }
      });
      if (status != 1) {
        this.disabledEE = false;
      }
    },
    // 图片删除
    handleRemoveEE(file, fileList) {
      this.eList = [];
      fileList.forEach((res) => {
        if (res.response == undefined) {
          this.eList.push(res);
        } else {
          this.eList.push(res.response.data);
        }
      });
    },
    // 富文本图片上传失败
    uploadErrorEE(err, file, fileList) {
      if (fileList.length > 0) {
        let status = "";
        fileList.some((res) => {
          if (res.status != "success") {
            status = 1;
            return;
          }
        });
        if (status != 1) {
          this.disabledEE = false;
        }
      } else {
        this.disabledEE = false;
      }
      // loading动画消失
      this.msgError("图片上传失败");
      this.loading = false;
    },

    // --------------------------------------------------------------
    beforeUploadFF(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension = testmsg === "pdf";
      const isLt2M = file.size / 1024 / 1024 <= 4;
      if (!extension) {
        this.msgError("上传文件只能是pdf文件");
      }

      if (!isLt2M) {
        this.msgError("上传文件大小不能超过4M");
      }
      let disabledCx = false;
      if (!extension && !isLt2M && this.disabledFF) {
        disabledCx = true;
      }
      if (extension && isLt2M) {
        disabledCx = true;
      }
      this.disabledFF = disabledCx;
      // this.loading=true;
      return extension && isLt2M;
    },
    // 上传成功
    quillImgSuccessFF(res, file, fileList) {
      this.loading = false;
      // 如果上传成功
      if (res.code === "00000") {
        this.fList.push({
          name: res.data.fileName,
          fileName: res.data.fileName,
          url: res.data.url,
          moduleId: res.data.moduleId,
          moduleType: res.data.moduleType,
          path: res.data.path,
        });
        this.msgSuccess("附件上传成功");
      } else {
        this.msgError("附件上传失败");
      }
      console.log(this.fList);
      let status = "";
      fileList.some((res) => {
        if (res.status != "success") {
          status = 1;
          return;
        }
      });
      if (status != 1) {
        this.disabledDD = false;
      }
    },
    // 图片删除
    handleRemoveFF(file, fileList) {
      this.fList = [];
      fileList.forEach((res) => {
        if (res.response == undefined) {
          this.fList.push(res);
        } else {
          this.fList.push(res.response.data);
        }
      });
    },
    // 富文本图片上传失败
    uploadErrorFF(err, file, fileList) {
      if (fileList.length > 0) {
        let status = "";
        fileList.some((res) => {
          if (res.status != "success") {
            status = 1;
            return;
          }
        });
        if (status != 1) {
          this.disabledFF = false;
        }
      } else {
        this.disabledFF = false;
      }
      // loading动画消失
      this.msgError("图片上传失败");
      this.loading = false;
    },
  },
};
</script>

<style scoped>
.row-bg {
  width: 84%;
  margin: 0 auto;
  flex-wrap: wrap;
}
.flex .el-button {
  margin-bottom: 10px;
}
.content {
  padding: 10px;
  background-color: #fff;
}
.tab-tilte {
  box-sizing: border-box;
  margin: 0 auto;
  width: 100%;
  display: flex;
  justify-content: center;
}
.tab-tilte li {
  line-height: 40px;
  padding: 0 20px;
  border: 1px solid #4988df;
  color: #4988df;
  margin: 0;
  box-sizing: border-box;
  list-style: none;
  cursor: pointer;
}
.tab-tilte .active {
  background: #4988df;
  color: #fff;
}
.tab-content > div {
  margin-top: 20px;
  width: 100%;
}
.tab-content .title {
  font-size: 13px;
  padding: 10px 20px;
  border-bottom: 1px solid #d4d4d4;
  position: relative;
}
.tab-content .title::before {
  content: "";
  position: absolute;
  width: 4px;
  height: 18px;
  left: 10px;
  top: 10px;
  background: #7c99fd;
}
.textarea {
  resize: none;
  width: 100%;
}
</style>
